<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="sp"> </p>
<p class="sp"> </p>
<p class="DED"><span class="ePub-I">For my mom &amp; the Wolfawitzes</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?318ca0de